import { CALL_PAGE } from "../common/constants"

import { createClientCallPath } from "modules/Call/routing"
import { CallStatus } from "modules/Call/queries"
import { AccessDevices } from "modules/Call/components/AccessDevices"
import { GoToCallButton } from "modules/Call/components/GoToCallButton"
import { InfoCard, UserInfo, SessionInfo } from "modules/Call/components/index"

interface Props {
    sessionDatetime: string
    sessionDuration: number
    psyName: string
    faceUrl: string
    titles: string[]
    bookingHash: string
    callStatus: CallStatus
    companionLocation: CALL_PAGE
}

export function LobbyInfoForClient({
    sessionDatetime,
    sessionDuration,
    psyName,
    faceUrl,
    titles,
    bookingHash,
    callStatus,
    companionLocation,
}: Props) {
    return (
        <InfoCard
            content={
                <>
                    <div className="info-card__header">Подготовьтесь к&nbsp;сессии</div>
                    <div className="info-card__welcome">
                        Позаботьтесь, чтобы вам было комфортно.
                    </div>
                    <AccessDevices />
                    <hr className="is-hidden-mobile mgt-1 mgb-3" />
                    <hr className="is-hidden-tablet mgt-3 mgb-3" />
                    <SessionInfo
                        sessionDatetime={sessionDatetime}
                        sessionDuration={sessionDuration}
                    />
                    <hr className="mgt-3 mgb-3" />
                    <UserInfo
                        displayName={psyName}
                        faceUrl={faceUrl}
                        titles={titles}
                        companionLocation={companionLocation}
                    />
                </>
            }
            footer={
                <GoToCallButton
                    callLink={createClientCallPath(`/room/${bookingHash}`)}
                    callStatus={callStatus}
                />
            }
        />
    )
}
